import { Button, Space, Typography } from "antd";
import React from "react";
import MasterComponent from "../../../../../../components/Forms";
import { MasterConfigs } from "../../../../../../interfaces/entity";

const AdHocComponents = () => {
    const config: MasterConfigs = {
        api: () => '/ad-hoc-components',
        modalTitle: () => "Ad-Hoc Components",
        tableProps: {
            scroll: { x: 500 },
        },
        getColumns: () => [
            {
                title: 'Component Name',
                dataIndex: 'name',
                key: 'name',
                width: 200,
                fixed: 'left',
            },
            {
                title: 'Tax Exempted',
                dataIndex: 'taxExempted',
                key: 'taxExempted',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No'
            },
            {
                title: 'Payable Tax',
                dataIndex: 'payableTax',
                key: 'payableTax',
                width: 150,
            },
            {
                title: 'Seprate Component Payment',
                dataIndex: 'seprateComponentPayment',
                key: 'seprateComponentPayment',
                width: 150,
            }
        ],
        getFormColumns: () => [
            {
                label: "Component Name",
                name: "name",
                type: "text",
                rules: [{ required: true, message: "Please enter component name!" }],
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 12,
                inputTextAreaProps: { rows: 1 }
            },
            {
                label: 'This component is tax exempted (Non taxable)',
                name: 'taxExempted',
                type: 'checkbox',
                span: 24,
            },
            {
                label: 'Do you deduct the payable tax on the component in the months it is paid?',
                name: 'payableTax',
                span: 24,
                type: 'radio',
                children: [
                    { name: 'Yes', value: 'Yes' },
                    { name: 'No', value: 'No' }
                ]
            },
            {
                label: 'Do you want to pay the component separately?',
                span: 24,
                name: 'seprateComponentPayment',
                type: 'radio',
                children: [
                    { name: 'Yes', value: 'Yes' },
                    { name: 'No', value: 'No' }
                ]
            },
            {
                type: 'custom',
                span: 24,
                formItem: () => <Space direction="vertical">
                    <Typography.Title level={5} style={{ lineHeight: 1.2, marginBottom: 0 }}>This component is Taxable</Typography.Title>
                    <Typography.Text>This component's taxability is set by the system and cannot be altered.</Typography.Text>
                </Space>
            }
        ],
        actions: [
            { actionType: 'Add', name: 'Add' },
        ],
    }
    return <MasterComponent config={config} isModal={true} />
}

export default AdHocComponents;